import { render, staticRenderFns } from "./EmailAlert.html?vue&type=template&id=4298d83c&scoped=true&"
import script from "./EmailAlert.vue?vue&type=script&lang=js&"
export * from "./EmailAlert.vue?vue&type=script&lang=js&"
import style0 from "./EmailAlert.vue?vue&type=style&index=0&id=4298d83c&scoped=true&lang=css&"
import style1 from "./EmailAlert.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298d83c",
  null
  
)

export default component.exports